"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Calendar, ChevronRight, CircleAlert } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function BeritaTerbaruGrid() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-6">
        {[...Array(5)].map((_, i) => <div key={i} className="aspect-[3/4] rounded-lg bg-muted animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center bg-muted/30 rounded-lg border border-border border-dashed">
        <CircleAlert className="size-10 text-primary mb-4" />
        <p className="text-muted-foreground mb-4">Gagal memuat berita.</p>
        <Button variant="outline" onClick={refetch}>Coba Lagi</Button>
      </div>;
  }
  if (posts.length === 0) return null;
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-6">
      {posts.map((post, i) => <Link key={post.id} to={post.link || "#"} className="group block h-full">
          <Card className="h-full overflow-hidden border border-border bg-card transition-all duration-300 hover:shadow-md rounded-lg">
            <div className="relative aspect-[4/3] overflow-hidden">
              <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/generic_news_placeholder.png"} alt={post.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
            </div>
            <CardContent className="p-4 flex flex-col gap-3">
              <Badge variant="secondary" className="w-fit bg-accent text-accent-foreground border-none">
                PILIHAN REDAKSI
              </Badge>
              <h3 className="font-bold text-foreground text-lg leading-snug line-clamp-3 group-hover:text-primary transition-colors">
                {post.title}
              </h3>
              <div className="mt-auto flex items-center gap-1.5 text-muted-foreground text-xs">
                <SafeHydrate><Calendar className="size-3" /></SafeHydrate>
                <time>{post.date || "Baru saja"}</time>
              </div>
            </CardContent>
          </Card>
        </Link>)}
    </div>;
}
export default function BeritaTerbaru() {
  return <section id="pilihan-redaksi" className="bg-background py-16">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-2xl font-bold tracking-tight text-foreground uppercase">
            Pilihan Redaksi
          </h2>
          <Link to="/NewsPage" className="inline-flex items-center gap-1 text-sm font-bold text-primary hover:text-primary/80 uppercase">
            Lihat Semua
            <ChevronRight className="size-4" />
          </Link>
        </div>

        <PostsProvider wp_query={{
        per_page: 5,
        order: "desc",
        orderby: "date",
        status: ["publish"]
      }}>
          <BeritaTerbaruGrid />
        </PostsProvider>
      </div>
    </section>;
}